import axios from "axios";
import { node_server, server_link } from "../constants";
const serverBaseUrl = `${node_server}/api/emails/`;
export const sendWelcomeEmail = async (receiverId) => {
  axios.get(serverBaseUrl + "shoutout-received" + "?userId=" + receiverId);
};
export const sendShoutOutReceivedEmail = async (receiverId) => {
  axios.get(serverBaseUrl + "shoutout-received" + "?userId=" + receiverId);
};

export const sendFeedbackEmail = async (userId, ticketNumber) => {
  axios.get(
    serverBaseUrl +
      "feedback" +
      "?userId=" +
      userId +
      "&ticketNumber=" +
      ticketNumber
  );
};

export const sendClassificationHelpEmail = async (userId, ticketNumber) => {
  axios.get(
    serverBaseUrl +
      "classification-help-received" +
      "?userId=" +
      userId +
      "&ticketNumber=" +
      ticketNumber
  );
};

export const sendProjectSubmissionEmail = async (userId, projectId) => {
  axios.get(
    serverBaseUrl +
      "project-submitted" +
      "?userId=" +
      userId +
      "&projectId=" +
      projectId
  );
};

export const sendRemovedByHostEmail = async (projectId, removedUserId) => {
  axios.get(
    serverBaseUrl +
      "removed-by-host" +
      "?userId=" +
      removedUserId +
      "&projectId=" +
      projectId
  );
};

export const sendProjectCompletedEmail = async (projectId, userId) => {
  axios.get(
    serverBaseUrl +
      "project-completed" +
      "?userId=" +
      userId +
      "&projectId=" +
      projectId
  );
};

export const sendProjectDeletedemail = async (projectId) => {
  axios.get(serverBaseUrl + "project-cancelled" + "?projectId=" + projectId);
};

export const sendProjectApplicationAcceptedEmail = async (
  applicantId,
  projectId
) => {
  axios.get(
    serverBaseUrl +
      "project-application-accepted" +
      "?applicantId=" +
      applicantId +
      "&projectId=" +
      projectId
  );
};

export const sendProjectCanceledByUserEmail = async (
  applicantId,
  projectId
) => {
  console.log(applicantId, projectId, "check apllicat id and project id ");
};

export const sendProjectApplyConfirmationEmail = async (
  applicantId,
  projectId
) => {
  axios.get(
    serverBaseUrl +
      "project-application-received" +
      "?userId=" +
      applicantId +
      "&projectId=" +
      projectId
  );
};

export const creator_withdrew = async (userId, projectId) => {
  axios.get(
    serverBaseUrl +
      "creator-withdrew" +
      "?userId=" +
      userId +
      "&projectId=" +
      projectId
  );
};

export const unsubscribe = async (userId) => {
  axios.get(serverBaseUrl + "unsubscribe" + "?userId=" + userId);
};
